import {combineReducers} from "redux";
import pirahasReducer from "./pirahas/feature"

export default combineReducers({
    pirahas: pirahasReducer,
})

